import React from "react";
import Slider from "react-slick";

const Gallery = (props) => {
  const slider = props.galleryCategories.filter((slides) => {return slides.name === "slider"})

    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplay:true,
        autoplaySpeed: 3000,
        slidesToShow: 3.9999,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 680,
                settings: {
                  slidesToShow: 1,
                }
              }
        ]
      };
    return props === undefined ? <div className="loading"></div> : (
        <>
        <div className="container-fluid gallerySlide">
            <div className="row">
                <h4 className="galleryh4 inPage"> Gallery</h4>
                <Slider {...sliderSettings} >
                {slider[0].galleries.map((gallery) => {
                  return (
                    <div className="galleryImages" key={gallery.id}><img src={process.env.REACT_APP_IMAGE_STORAGE + gallery.image} alt="" className="galleryImage" /></div>
                  )
                })}
               </Slider>
            </div>
        </div>
        </>
    );
};

export default Gallery;